import Utils from './utils'

const GOOGLE_ADS_COOKIE = '_gcl_aw'
const CLICK_ID_PATTERN = /^[A-Za-z0-9_-]+$/
const CLICK_ID_MAX_LENGTH = 512

export const isValidGoogleClickId = (value?: string | null): value is string =>
    typeof value === 'string' && value.length <= CLICK_ID_MAX_LENGTH && CLICK_ID_PATTERN.test(value)

export const gclidFromCookie = (cookieValue?: string | null): string | undefined => {
    if (!cookieValue) return undefined
    const parts = cookieValue.split('.')
    if (parts.length < 3 || parts[0] !== 'GCL') return undefined
    const gclid = parts.slice(2).join('.')
    return isValidGoogleClickId(gclid) ? gclid : undefined
}

export const gclidFromSearch = (search: string): string | undefined => {
    const gclid = new URLSearchParams(search).get('gclid')
    return isValidGoogleClickId(gclid) ? gclid : undefined
}

export const readGclid = (): string | undefined => {
    try {
        return gclidFromCookie(Utils.getCookie(GOOGLE_ADS_COOKIE)) ?? gclidFromSearch(window.location.search)
    } catch {
        return undefined
    }
}

export const gclidParam = (): { gclid?: string } => {
    const gclid = readGclid()
    return gclid ? { gclid } : {}
}
